<template>
  <div class="device-monitor-page">
    <section class="monitor-shell">
      <header class="monitor-header">
        <div>
          <div class="eyebrow">Device Monitoring</div>
          <h1>设备监测</h1>
        </div>
      </header>

      <div class="filter-panel">
        <button
          type="button"
          class="filter-toggle"
          :class="{ 'is-open': mobileFiltersOpen }"
          :aria-expanded="String(mobileFiltersOpen)"
          @click="mobileFiltersOpen = !mobileFiltersOpen"
        >
          <span><i class="el-icon-s-operation"></i>筛选条件</span>
          <i class="el-icon-arrow-down"></i>
        </button>
        <div class="filter-fields" :class="{ 'is-mobile-collapsed': !mobileFiltersOpen }">
          <label class="filter-item filter-device">
            <span>设备名称</span>
            <el-select v-model="query.id" placeholder="请选择设备名称" clearable filterable>
              <el-option
                v-for="item in deviceList"
                :key="item.id"
                :label="item.deviceName || '未命名设备'"
                :value="item.id"
              ></el-option>
            </el-select>
          </label>
          <label class="filter-item">
            <span>设备状态</span>
            <el-select v-model="query.onlineStatus" placeholder="全部状态" clearable>
              <el-option value="1" label="离线"></el-option>
              <el-option value="2" label="在线"></el-option>
            </el-select>
          </label>
          <label class="filter-item">
            <span>设备类型</span>
            <el-select v-model="query.stationType1" placeholder="全部类型" clearable>
              <el-option value="1" label="控制器"></el-option>
              <el-option value="2" label="电表"></el-option>
            </el-select>
          </label>
        </div>
        <el-button type="primary" icon="el-icon-search" class="search-btn" @click="serch">搜索</el-button>
      </div>

      <main class="device-grid-wrap">
        <div v-if="tableData.length === 0" class="empty-state">
          <i class="el-icon-data-analysis"></i>
          <span>暂无设备数据</span>
        </div>
        <article
          v-for="item in tableData"
          v-else
          :key="item.id"
          class="device-card"
        >
          <div class="card-main">
            <div class="device-visual">
              <img
                v-if="item.picUrl"
                class="device-photo"
                :src="item.picUrl"
                :alt="displayName(item)"
                @click.stop="openImagePreview(item)"
              />
              <i v-else class="el-icon-cpu"></i>
            </div>
            <div class="device-info">
              <div class="device-title-row">
                <h2 :title="displayName(item)">{{ displayName(item) }}</h2>
                <div class="title-actions">
                  <span class="status-pill" :class="statusClass(item.deviceStatus)">
                    {{ statusText(item.deviceStatus) }}
                  </span>
                  <el-button
                    type="primary"
                    size="mini"
                    plain
                    icon="el-icon-view"
                    class="detail-btn"
                    :disabled="item.deviceType !== 1 && item.deviceType !== 2"
                    @click="openDetail(item)"
                  >
                    详情
                  </el-button>
                </div>
              </div>
              <dl>
                <div>
                  <dt>设备站点</dt>
                  <dd :title="safeText(item.stationName)">{{ safeText(item.stationName) }}</dd>
                </div>
                <div>
                  <dt>设备类型</dt>
                  <dd>{{ deviceTypeText(item.deviceType) }}</dd>
                </div>
                <div>
                  <dt>设备地址</dt>
                  <dd :title="safeText(item.address)">{{ safeText(item.address) }}</dd>
                </div>
                <div>
                  <dt>版本号</dt>
                  <dd>{{ safeText(item.versionNo) }}</dd>
                </div>
              </dl>
            </div>
          </div>
        </article>
      </main>

      <footer class="pagination-box">
        <el-pagination
          :current-page="query.pageNum"
          :page-size="query.pageSize"
          :total="total"
          layout="prev, pager, next, jumper"
          background
          @current-change="onPageChange"
        />
      </footer>
    </section>

    <el-dialog
      ref="kzqDetailDialog"
      title="控制器详情"
      :visible.sync="showKzqForm"
      :fullscreen="screenWidth <= 760"
      append-to-body
      @close="showKzqForm = false"
      @opened="focusDetailContent('kzqDetailDialog', '控制器详情内容')"
      top="2vh"
      width="90vw"
      custom-class="monitor-dialog"
    >
      <deviceKzqViewVue :id="optId" v-if="showKzqForm" />
    </el-dialog>

    <el-dialog
      ref="dbDetailDialog"
      title="电表详情"
      :visible.sync="showDbForm"
      :fullscreen="screenWidth <= 760"
      append-to-body
      @close="showDbForm = false"
      @opened="focusDetailContent('dbDetailDialog', '电表详情内容')"
      top="2vh"
      width="90vw"
      custom-class="monitor-dialog"
    >
      <deviceDbViewVue :id="optId" v-if="showDbForm" />
    </el-dialog>

    <div v-if="imagePreviewVisible" class="image-preview-mask" @click.self="closeImagePreview">
      <button class="preview-close" type="button" @click="closeImagePreview">
        <i class="el-icon-close"></i>
      </button>
      <button
        class="preview-nav preview-prev"
        type="button"
        :disabled="imagePreviewList.length <= 1"
        @click.stop="switchPreviewImage(-1)"
      >
        <i class="el-icon-arrow-left"></i>
      </button>
      <img
        class="preview-image"
        :src="currentPreviewImage"
        :alt="currentPreviewTitle"
      />
      <button
        class="preview-nav preview-next"
        type="button"
        :disabled="imagePreviewList.length <= 1"
        @click.stop="switchPreviewImage(1)"
      >
        <i class="el-icon-arrow-right"></i>
      </button>
      <div class="preview-counter">{{ imagePreviewIndex + 1 }} / {{ imagePreviewList.length }}</div>
    </div>
  </div>
</template>

<script>
import deviceKzqViewVue from './deviceKzqView.vue';
import deviceDbViewVue from './deviceDbView.vue';

export default {
  name: 'deviceJianCeVue',
  props: {
    id: {
      required: false,
      type: Number
    }
  },
  components: {
    deviceKzqViewVue,
    deviceDbViewVue
  },
  data() {
    return {
      screenHeight: 0,
      screenWidth: 0,
      showDbForm: false,
      showKzqForm: false,
      imagePreviewVisible: false,
      imagePreviewIndex: 0,
      mobileFiltersOpen: false,
      optId: null,
      tableData: [],
      total: 0,
      query: {
        pageNum: 1,
        pageSize: 12,
        id: null,
        onlineStatus: '',
        stationType1: '',
        deviceStatus: ''
      },
      deviceList: []
    };
  },
  computed: {
    imagePreviewList() {
      return this.tableData.filter(item => item.picUrl).map(item => item.picUrl);
    },
    currentPreviewImage() {
      return this.imagePreviewList[this.imagePreviewIndex] || '';
    },
    currentPreviewTitle() {
      const url = this.currentPreviewImage;
      const item = this.tableData.find(row => row.picUrl === url);
      return item ? this.displayName(item) : '';
    }
  },
  mounted() {
    if (this.id != null) this.query.id = this.id;

    if (this.$route.query.deviceStatus) {
      const status = this.$route.query.deviceStatus;
      this.query.deviceStatus = status;
      this.query.onlineStatus = status;
    }

    this.loadAllList();
    this.loadPage();
    this.updateScreenWidth();
    window.addEventListener('resize', this.updateScreenWidth);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateScreenWidth);
  },
  methods: {
    updateScreenWidth() {
      this.screenWidth = window.innerWidth;
      this.screenHeight = window.innerHeight;
    },
    onPageChange(val) {
      this.query.pageNum = val;
      this.loadPage();
    },
    serch() {
      this.query.pageNum = 1;
      this.loadPage();
    },
    loadPage() {
      const params = { ...this.query };
      if (params.onlineStatus) {
        params.deviceStatus = params.onlineStatus;
      }
      delete params.onlineStatus;

      this.$request.post('/api/device/page', params).then(response => {
        if (response.data.result) {
          const data = response.data.data || {};
          this.tableData = Array.isArray(data.list) ? data.list : [];
          this.total = data.totalCount || 0;
        } else {
          this.notifyError('获取设备数据失败，请联系管理员！');
        }
      }).catch(() => {
        this.notifyError('网络异常，获取设备数据失败！');
      });
    },
    loadAllList() {
      const queryForm = { pageNum: 1, pageSize: 10000 };
      this.$request.post('/api/device/page', queryForm).then(response => {
        if (response.data.result) {
          const data = response.data.data || {};
          this.deviceList = Array.isArray(data.list) ? data.list : [];
        } else {
          this.notifyError('获取设备列表失败，请联系管理员！');
        }
      }).catch(() => {
        this.notifyError('网络异常，获取设备列表失败！');
      });
    },
    openDetail(item) {
      this.optId = item.id;
      if (item.deviceType === 1) this.showKzqForm = true;
      if (item.deviceType === 2) this.showDbForm = true;
    },
    focusDetailContent(refName, label) {
      this.$nextTick(() => {
        const dialog = this.$refs[refName];
        const content = dialog && dialog.$el.querySelector('.el-dialog__body');
        if (!content) return;

        content.setAttribute('tabindex', '0');
        content.setAttribute('aria-label', label);
        content.focus({ preventScroll: true });
      });
    },
    openImagePreview(item) {
      const index = this.imagePreviewList.indexOf(item.picUrl);
      this.imagePreviewIndex = index >= 0 ? index : 0;
      this.imagePreviewVisible = true;
    },
    closeImagePreview() {
      this.imagePreviewVisible = false;
    },
    switchPreviewImage(step) {
      const total = this.imagePreviewList.length;
      if (total <= 1) return;
      this.imagePreviewIndex = (this.imagePreviewIndex + step + total) % total;
    },
    displayName(item) {
      return item.deviceName || item.stationName || '未命名设备';
    },
    safeText(value) {
      return value || '--';
    },
    statusText(status) {
      const statusMap = {
        1: '离线',
        2: '在线',
        3: '故障',
        4: '告警'
      };
      return statusMap[status] || '未知';
    },
    statusClass(status) {
      return {
        'is-offline': status === 1,
        'is-online': status === 2,
        'is-fault': status === 3,
        'is-alarm': status === 4
      };
    },
    deviceTypeText(type) {
      const typeMap = {
        1: '控制器',
        2: '电表',
        3: '逆变器'
      };
      return typeMap[type] || '--';
    },
    notifyError(message) {
      if (this.$message) {
        this.$message.error(message);
        return;
      }
      if (this.$Message) this.$Message.error(message);
    }
  }
};
</script>

<style scoped>
.device-monitor-page {
  width: 100%;
  height: 100%;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  box-sizing: border-box;
  overflow: hidden;
  background:
    linear-gradient(135deg, rgba(var(--solar-primary-rgb, 0, 153, 255), 0.08), transparent 34%),
    var(--solar-page, #001a33);
}

.monitor-shell {
  width: 100%;
  max-width: 100%;
  height: calc(100vh - 104px);
  max-height: calc(100vh - 104px);
  min-height: 0;
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(var(--solar-border-strong-rgb, 63, 184, 255), 0.45);
  border-radius: 8px;
  background: rgba(var(--solar-page-rgb, 0, 31, 61), 0.92);
  box-shadow: 0 18px 40px rgba(0, 7, 18, 0.32), inset 0 1px 0 rgba(176, 226, 255, 0.18);
  box-sizing: border-box;
  overflow: hidden;
}

.monitor-header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 16px 22px 14px;
  border-bottom: 1px solid rgba(var(--solar-border-strong-rgb, 63, 184, 255), 0.28);
  background: linear-gradient(90deg, rgba(var(--solar-surface-rgb, 0, 43, 77), 0.92), rgba(var(--solar-page-rgb, 0, 26, 51), 0.72));
}

.eyebrow {
  color: var(--solar-text, #7bdff2);
  font-size: 12px;
  line-height: 18px;
  text-transform: uppercase;
}

.monitor-header h1 {
  margin: 2px 0 0;
  color: var(--solar-text-strong, #effcff);
  font-size: 24px;
  line-height: 32px;
  font-weight: 700;
}

.filter-panel {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 16px;
  align-items: center;
  padding: 14px 22px;
  border-bottom: 1px solid rgba(var(--solar-border-strong-rgb, 63, 184, 255), 0.2);
  background: rgba(var(--solar-page-rgb, 0, 26, 51), 0.34);
}

.filter-fields {
  display: contents;
}

.filter-toggle {
  display: none;
}

.filter-item {
  display: flex;
  align-items: center;
  min-width: 0;
  flex: 0 0 auto;
  gap: 8px;
  color: var(--solar-text, #9edcf4);
  font-size: 14px;
  line-height: 20px;
}

.filter-item:nth-child(1),
.filter-item:nth-child(3) {
  width: 190px;
}

.filter-item:nth-child(2) {
  width: 248px;
}

.filter-device {
  width: 268px;
}

.filter-item > span {
  flex: 0 0 auto;
  text-align: left;
  white-space: nowrap;
}

/deep/ .filter-item .el-input,
/deep/ .filter-item .el-select {
  flex: 1 1 auto;
  width: auto;
  min-width: 0;
}

.search-btn {
  width: 108px;
  height: 36px;
  margin-left: auto;
  border-radius: 4px;
  background: var(--solar-primary, #0099FF) !important;
  border-color: var(--solar-border-strong, #0099FF) !important;
  color: var(--solar-on-primary, #002B4D) !important;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
}

/deep/ .search-btn [class*="el-icon-"] + span,
/deep/ .detail-btn [class*="el-icon-"] + span {
  margin-left: 6px;
}

.device-grid-wrap {
  flex: 1 1 auto;
  width: 100%;
  max-width: 100%;
  min-height: 0;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  grid-auto-rows: max-content;
  align-content: center;
  align-content: safe center;
  align-items: start;
  gap: 14px;
  padding: 16px 22px;
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
}

.device-card {
  max-width: 100%;
  min-width: 0;
  min-height: 156px;
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(var(--solar-border-strong-rgb, 63, 184, 255), 0.28);
  border-radius: 8px;
  background: linear-gradient(180deg, rgba(var(--solar-raised-rgb, 0, 54, 90), 0.74), rgba(var(--solar-page-rgb, 0, 31, 61), 0.84));
  box-shadow: 0 10px 22px rgba(0, 10, 24, 0.18);
  overflow: hidden;
  transition: border-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
}

.device-card:hover {
  transform: translateY(-2px);
  border-color: rgba(116, 208, 255, 0.72);
  box-shadow: 0 16px 28px rgba(0, 10, 24, 0.28);
}

.card-main {
  display: flex;
  align-items: stretch;
  gap: 14px;
  padding: 18px 14px;
  min-width: 0;
}

.device-visual {
  position: relative;
  width: 94px;
  min-height: 0;
  flex: 0 0 94px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(135, 206, 250, 0.24);
  border-radius: 6px;
  background: rgba(var(--solar-page-rgb, 0, 18, 36), 0.46);
  overflow: hidden;
}

.device-photo {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: zoom-in;
}

.device-visual i {
  color: var(--solar-text, #62d0ff);
  font-size: 36px;
}

.device-info {
  min-width: 0;
  flex: 1;
}

.device-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  min-width: 0;
}

.title-actions {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.device-title-row h2 {
  margin: 0;
  min-width: 0;
  color: var(--solar-text-strong, #f3fdff);
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.status-pill {
  flex-shrink: 0;
  min-width: 52px;
  height: 24px;
  padding: 0 9px;
  border-radius: 999px;
  color: var(--solar-text-strong, #cfe9f6);
  background: rgba(135, 206, 250, 0.16);
  font-size: 12px;
  line-height: 24px;
  text-align: center;
}

.status-pill.is-online {
  color: var(--solar-text, #56f0b2);
  background: rgba(79, 227, 164, 0.12);
}

.status-pill.is-offline {
  color: var(--solar-danger, #ff9b9b);
  background: rgba(255, 112, 112, 0.13);
}

.status-pill.is-fault,
.status-pill.is-alarm {
  color: var(--solar-warning, #ffd166);
  background: rgba(255, 209, 102, 0.14);
}

/deep/ .detail-btn.el-button {
  height: 26px;
  min-width: 62px;
  margin: 0 !important;
  padding: 5px 9px !important;
  border-radius: 13px;
  line-height: 1;
  box-sizing: border-box;
}

/deep/ .detail-btn.el-button [class*="el-icon-"] + span {
  margin-left: 4px;
}

/deep/ .detail-btn.el-button.is-disabled,
/deep/ .detail-btn.el-button.is-disabled:hover {
  border-color: rgba(135, 206, 250, 0.2) !important;
  background: rgba(135, 206, 250, 0.08) !important;
  color: rgba(var(--solar-text-strong-rgb, 191, 239, 255), 0.45) !important;
}

.device-info dl {
  margin: 10px 0 0;
}

.device-info dl > div {
  display: grid;
  grid-template-columns: 66px minmax(0, 1fr);
  gap: 8px;
  align-items: center;
  min-height: 24px;
}

.device-info dt,
.device-info dd {
  margin: 0;
  font-size: 13px;
  line-height: 20px;
}

.device-info dt {
  color: var(--solar-muted, #82b6ce);
}

.device-info dd {
  color: var(--solar-text-strong, #d9f5ff);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.empty-state {
  grid-column: 1 / -1;
  height: 100%;
  min-height: 260px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: var(--solar-text, #89c8e4);
  border: 1px dashed rgba(135, 206, 250, 0.24);
  border-radius: 8px;
  background: rgba(var(--solar-page-rgb, 0, 26, 51), 0.3);
}

.empty-state i {
  font-size: 34px;
  color: var(--solar-text, #66d9ef);
}

.pagination-box {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-height: 58px;
  padding: 10px 22px;
  border-top: 1px solid rgba(var(--solar-border-strong-rgb, 63, 184, 255), 0.2);
  background: rgba(var(--solar-page-rgb, 0, 18, 36), 0.3);
  box-sizing: border-box;
}

/deep/ .pagination-box .el-pagination,
/deep/ .pagination-box .el-pagination > span,
/deep/ .pagination-box .el-pagination > button,
/deep/ .pagination-box .el-pagination .el-pager {
  display: flex;
  align-items: center;
}

/deep/ .pagination-box .el-pagination {
  justify-content: flex-end;
  line-height: 1;
}

/deep/ .pagination-box .el-pagination > span,
/deep/ .pagination-box .el-pagination > button,
/deep/ .pagination-box .el-pagination .el-pager li,
/deep/ .pagination-box .el-pagination .el-pagination__jump,
/deep/ .pagination-box .el-pagination .el-pagination__editor,
/deep/ .pagination-box .el-pagination .el-input__inner {
  height: 32px;
  line-height: 32px;
}

/deep/ .pagination-box .el-pagination .el-pager li,
/deep/ .pagination-box .el-pagination > button,
/deep/ .pagination-box .el-pagination .el-pagination__jump,
/deep/ .pagination-box .el-pagination .el-pagination__editor,
/deep/ .pagination-box .el-pagination .el-input__inner {
  display: flex;
  align-items: center;
  justify-content: center;
}

/deep/ .pagination-box .el-pagination > button {
  padding: 0;
}

/deep/ .pagination-box .el-pagination > button i,
/deep/ .pagination-box .el-pagination > button span {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

/deep/ .pagination-box .el-pagination .el-pagination__editor,
/deep/ .pagination-box .el-pagination .el-pagination__editor.el-input,
/deep/ .pagination-box .el-pagination .el-pagination__editor .el-input {
  height: 38px !important;
  line-height: 38px !important;
  border: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
  overflow: visible !important;
}

/deep/ .pagination-box .el-pagination .el-input__inner,
/deep/ .pagination-box .el-pagination .el-pagination__editor .el-input__inner {
  height: 38px !important;
  min-height: 38px !important;
  line-height: 38px !important;
  border: 1px solid var(--solar-border-strong, #0099ff) !important;
  border-radius: 4px !important;
  background: var(--solar-page, #001a33) !important;
  box-shadow: none !important;
  box-sizing: border-box !important;
}

.image-preview-mask {
  position: fixed;
  inset: 0;
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 8, 18, 0.88);
}

.preview-image {
  max-width: calc(100vw - 180px);
  max-height: calc(100vh - 120px);
  object-fit: contain;
  box-shadow: 0 18px 42px rgba(0, 0, 0, 0.42);
}

.preview-close,
.preview-nav {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(135, 206, 250, 0.42);
  background: rgba(var(--solar-page-rgb, 0, 31, 61), 0.82);
  color: var(--solar-text-strong, #dff8ff);
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease, opacity 0.2s ease;
}

.preview-close:hover,
.preview-nav:hover {
  border-color: rgba(116, 208, 255, 0.88);
  background: rgba(var(--solar-primary-rgb, 10, 149, 217), 0.82);
}

.preview-close {
  top: 24px;
  right: 28px;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  font-size: 22px;
}

.preview-nav {
  top: 50%;
  width: 52px;
  height: 64px;
  border-radius: 6px;
  font-size: 28px;
  transform: translateY(-50%);
}

.preview-prev {
  left: 28px;
}

.preview-next {
  right: 28px;
}

.preview-nav:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.preview-counter {
  position: absolute;
  left: 50%;
  bottom: 26px;
  min-width: 72px;
  height: 30px;
  padding: 0 12px;
  border: 1px solid rgba(135, 206, 250, 0.28);
  border-radius: 15px;
  background: rgba(var(--solar-page-rgb, 0, 31, 61), 0.72);
  color: var(--solar-text-strong, #dff8ff);
  font-size: 14px;
  line-height: 30px;
  text-align: center;
  transform: translateX(-50%);
  box-sizing: border-box;
}

/deep/ .el-input__inner {
  height: 36px;
  line-height: 36px;
  border-color: rgba(var(--solar-border-strong-rgb, 63, 184, 255), 0.58) !important;
  background: rgba(var(--solar-page-rgb, 0, 18, 36), 0.72) !important;
  color: var(--solar-text-strong, #dff8ff) !important;
}

/deep/ .el-input__inner::placeholder {
  color: var(--solar-muted, #6d9db6);
}

/deep/ .el-select {
  width: 100%;
}

/deep/ .el-button--primary {
  background: var(--solar-primary, #0099FF) !important;
  border-color: var(--solar-border-strong, #0099FF) !important;
  color: var(--solar-on-primary, #002B4D) !important;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
}

/deep/ .el-button--primary.is-plain {
  background: rgba(var(--solar-primary-rgb, 10, 149, 217), 0.12) !important;
  border-color: rgba(84, 195, 255, 0.56) !important;
  color: var(--solar-text-strong, #bfefff) !important;
}

/deep/ .el-button--primary.is-plain:hover {
  background: var(--solar-primary, #0a95d9) !important;
  border-color: var(--solar-border-strong, #0a95d9) !important;
  color: var(--solar-text-strong, #ffffff) !important;
}

/deep/ .el-pagination.is-background .btn-next,
/deep/ .el-pagination.is-background .btn-prev,
/deep/ .el-pagination.is-background .el-pager li {
  background-color: rgba(var(--solar-surface-rgb, 0, 43, 77), 0.86);
  color: var(--solar-text, #9edcf4);
}

/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: var(--solar-primary, #0a95d9);
  color: var(--solar-text-strong, #ffffff);
}

.device-grid-wrap::-webkit-scrollbar {
  width: 8px;
  height: 0;
}

.device-grid-wrap::-webkit-scrollbar:horizontal {
  display: none;
}

.device-grid-wrap::-webkit-scrollbar-track {
  background: rgba(var(--solar-page-rgb, 0, 18, 36), 0.45);
  border-radius: 8px;
}

.device-grid-wrap::-webkit-scrollbar-thumb {
  background: rgba(84, 195, 255, 0.48);
  border-radius: 8px;
}

/deep/ .search-btn.el-button {
  background-color: var(--solar-primary, #0099FF) !important;
  border-color: var(--solar-border-strong, #0099FF) !important;
  color: var(--solar-on-primary, #002B4D) !important;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
}

/deep/ .detail-btn.el-button {
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
}

@media (max-width: 1200px) {
  .monitor-header {
    align-items: center;
  }

  .filter-panel {
    gap: 12px;
  }
}

@media (max-width: 760px) {
  .device-monitor-page {
    padding: 10px;
  }

  .monitor-shell {
    height: calc(100vh - 76px);
    max-height: calc(100vh - 76px);
  }

  .filter-panel {
    display: block;
    padding: 8px 10px 10px;
  }

  .filter-toggle {
    width: 100%;
    height: 36px;
    margin: 0 0 8px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid rgba(var(--solar-border-strong-rgb, 63, 184, 255), 0.38);
    border-radius: 5px;
    background: rgba(var(--solar-surface-rgb, 0, 43, 77), 0.64);
    color: var(--solar-text-strong, #bfeeff);
    font: inherit;
  }

  .filter-toggle span {
    display: inline-flex;
    align-items: center;
    gap: 7px;
  }

  .filter-toggle > .el-icon-arrow-down {
    transition: transform 0.2s ease;
  }

  .filter-toggle.is-open > .el-icon-arrow-down {
    transform: rotate(180deg);
  }

  .filter-fields {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 8px;
  }

  .filter-fields.is-mobile-collapsed {
    display: none;
  }

  .filter-item,
  .filter-device {
    width: 100%;
  }

  .filter-item > span {
    text-align: left;
  }

  .search-btn {
    width: 100%;
    margin-left: 0;
  }

  .device-grid-wrap {
    grid-template-columns: 1fr;
    padding: 12px;
  }

  .card-main {
    flex-direction: column;
  }

  .device-visual {
    width: 100%;
    height: 120px;
    flex-basis: auto;
  }
}
</style>

<style>
.monitor-dialog {
  display: flex;
  flex-direction: column;
  max-height: 96vh;
  margin-bottom: 2vh !important;
  overflow: hidden;
  background: var(--solar-page, #00233f) !important;
  border: 1px solid rgba(var(--solar-border-strong-rgb, 63, 184, 255), 0.55);
}

.monitor-dialog .el-dialog__header {
  flex: 0 0 auto;
  border-bottom: 1px solid rgba(var(--solar-border-strong-rgb, 63, 184, 255), 0.24);
}

.monitor-dialog .el-dialog__body {
  flex: 1 1 auto;
  min-height: 0;
  max-height: calc(96vh - 56px);
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  outline: none;
}

.monitor-dialog .el-dialog__body:focus-visible {
  box-shadow: inset 0 0 0 1px rgba(84, 195, 255, 0.48);
}

.monitor-dialog .el-dialog__body::-webkit-scrollbar {
  width: 8px;
}

.monitor-dialog .el-dialog__body::-webkit-scrollbar-track {
  background: rgba(var(--solar-page-rgb, 0, 18, 36), 0.45);
}

.monitor-dialog .el-dialog__body::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: rgba(84, 195, 255, 0.58);
}

.monitor-dialog .el-dialog__title,
.monitor-dialog .el-dialog__close {
  color: var(--solar-text-strong, #dff8ff) !important;
}

@media (max-width: 760px) {
  .monitor-dialog,
  .monitor-dialog.el-dialog--center,
  .monitor-dialog.is-fullscreen {
    width: 100% !important;
    height: 100vh;
    height: 100dvh;
    max-height: 100vh;
    max-height: 100dvh;
    margin: 0 !important;
    border: 0;
    border-radius: 0;
  }

  .monitor-dialog .el-dialog__header {
    min-height: 52px;
    padding: 15px 52px 13px 16px;
    box-sizing: border-box;
    background: var(--solar-surface, #002b4d);
  }

  .monitor-dialog .el-dialog__title {
    display: block;
    overflow: hidden;
    font-size: 17px;
    line-height: 24px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .monitor-dialog .el-dialog__headerbtn {
    top: 0;
    right: 0;
    width: 52px;
    height: 52px;
    font-size: 20px;
  }

  .monitor-dialog .el-dialog__body {
    max-height: none;
    padding: 12px;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
  }
}
</style>
